// @ts-nocheck
import { merge } from 'lodash';
import language from 'ra-language-spanish';
import { TranslationMessages } from 'react-admin';
import en from './en';
import packageLanguage from './packages/es.json';

const lang: TranslationMessages = merge({}, en, language, packageLanguage);

export default lang;
